import { AppParamsContext } from 'contexts/AppParamsContext';
import { useContext } from 'react';
import Categories from 'views/Welcome/WelcomeScreenV2/HomeScreenTypes/Categories';
import ContentBox from 'views/Welcome/WelcomeScreenV2/HomeScreenTypes/ContentBox';
import Coupons from 'views/Welcome/WelcomeScreenV2/HomeScreenTypes/Coupons';
import HomeScreenElements from 'views/Welcome/WelcomeScreenV2/HomeScreenTypes/HomeScreenElements';
import PreviousOrderElements from 'views/Welcome/WelcomeScreenV2/HomeScreenTypes/PreviousOrderElements';
import VIPCard from 'views/Welcome/WelcomeScreenV2/HomeScreenTypes/VIPCard';

function WelcomeScreenV2() {
  const { appParams } = useContext(AppParamsContext);

  const renderCorrectElement = (element) => {
    switch (element?.type) {
      case 'categories':
        return <Categories key={element?.key} element={element} />;
      case 'previousOrderElements':
        return <PreviousOrderElements key={element?.key} element={element} />;
      case 'contentBox':
        return <ContentBox key={element?.key} element={element} />;
      case 'coupons':
        return <Coupons key={element?.key} element={element} />;
      case 'homeScreenElements':
        return <HomeScreenElements key={element?.key} element={element} />;
      case 'vipCard':
        return <VIPCard key={element?.key} element={element} />;
      default:
    }
  };
  return (
    <div className='flex flex-col gap-4 w-full'>
      {appParams?.homeScreen?.elements
        ?.sort((a, b) => {
          return a?.idx - b?.idx;
        })
        ?.map((element) => renderCorrectElement(element))}
    </div>
  );
}

export default WelcomeScreenV2;
